<div class="add-liens-taches">
  <span class="form_label">Lier à</span>
  <button class="button-grey-30" (click)='choixLienVisible=!choixLienVisible'>
    <i class="icon icon-plus"></i>
    Ajouter une liaison
  </button>
  @if (choixLienVisible) {
    <app-choix-type-lien (typeLienSelected)="showSelectorForType($event)"></app-choix-type-lien>
  }
</div>


<div class="liste-selecteurs-liens">
  @if (isSelectorVisible(TypeLien.personne)) {
    <app-choix-lien [formControl]="personnesControl"
    [typeLien]="TypeLien.personne" [undeletableIds]="undeletablePersonneIds"></app-choix-lien>
  }
  @if (isSelectorVisible(TypeLien.formateur)) {
    <app-choix-lien [formControl]="formateurControl"
    [typeLien]="TypeLien.formateur" [undeletableIds]="undeletableFormateurIds"></app-choix-lien>
  }
  @if (isSelectorVisible(TypeLien.entreprise)) {
    <app-choix-lien [formControl]="entreprisesControl"
    [typeLien]="TypeLien.entreprise" [undeletableIds]="undeletableEntrepriseIds"></app-choix-lien>
  }
  @if (isSelectorVisible(TypeLien.session)) {
    <app-choix-lien [formControl]="sessionsControl"
    [typeLien]="TypeLien.session" [undeletableIds]="undeletableSessionIds"></app-choix-lien>
  }
  @if (isSelectorVisible(TypeLien.personnel)) {
    <app-choix-lien [formControl]="personnelsControl"
    [typeLien]="TypeLien.personnel" [undeletableIds]="undeletableSessionIds"></app-choix-lien>
  }
</div>